import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gb_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/admin") && !window.location.pathname.endsWith("/login")) {
      localStorage.removeItem("gb_admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const INTEREST_LABELS = {
  csak_erdekel: "Csak érdekel",
  "1_zsak": "1 zsák érdekel",
  "2_3_zsak": "2–3 zsák érdekel",
  "4_10_zsak": "4–10 zsák érdekel",
  "10plusz_zsak": "10+ zsák érdekel",
  nem_tudom: "Még nem tudom",
};

export const COUPON_STATUS_LABELS = {
  AKTIV: "AKTÍV",
  FELHASZNALVA: "FELHASZNÁLVA",
  LEJART: "LEJÁRT",
  ERVENYTELEN: "ÉRVÉNYTELEN",
};

export function parseUtmParams() {
  const sp = new URLSearchParams(window.location.search);
  return {
    utm_source: sp.get("utm_source") || sp.get("source"),
    utm_medium: sp.get("utm_medium"),
    utm_campaign: sp.get("utm_campaign"),
    landing_page: window.location.pathname + window.location.search,
  };
}
